import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import cn from 'classnames';
import style from './ServerAppContentHeader.module.scss';
import { LABEL } from '@veriables';
import { TouchableButton, TouchableDiv } from '@components/common/Touchable';
import { ReactComponent as DeleteIcon } from '@assets/images/delete.svg';
import plusSign from '@assets/images/plusSign.svg';
import MenuSeats from '../MenuSeats';
import AddSeatModal from '../../Modals/AddSeatModal';
import DeleteSeatModal from '../../Modals/DeleteSeatModal/index';
import { setPosition } from '@reducers/orders';

const ServerAppContentHeader = props => {
  const { serverAppTheme } = props;
  const [isAddSeatModalOpen, setIsAddSeatModalOpen] = useState(false);
  const [isDeleteSeatModalOpen, setIsDeleteSeatModalOpen] = useState(false);

  const addSeatServerAppScreen = useMemo(() => {
    const backgroundColor = {
      backgroundColor: serverAppTheme?.background_color,
    };
    const tableButton = {
      backgroundColor:
        props?.position?.number === -1
          ? serverAppTheme?.primaryBtn
          : props?.cart?.length > 0
          ? serverAppTheme?.pending_items
          : serverAppTheme?.tip_tile,
      color:
        props.position.number === -1 ? 'white' : serverAppTheme?.primary_text,
    };
    const buttonContainer = {
      backgroundColor: serverAppTheme?.background_color,
    };
    const delButton = { backgroundColor: serverAppTheme?.primaryBtn };

    return { backgroundColor, tableButton, buttonContainer, delButton };
  }, [serverAppTheme, props.position, props?.cart]);

  return (
    <div className={cn('row col-12', style.menuContentHeaderRow)}>
      <div
        className={cn(
          // style.bgColor, Class not in css file
          'pb-2 m-0 w-100 d-flex justify-content-between '
        )}
      >
        <>
          <div className={cn('d-flex p-0 fs-12')} style={{ overflow: 'hidden' }}>
            <div className="pr-1" style={{ flexShrink: 0 }}>
              <TouchableDiv
                role="presentation"
                onClick={() => {
                  props.setPosition({ number: -1, position: -1 });
                }}
                className={cn(
                  style.btnStyle,
                  props.position.number === -1
                    ? `${style.selectedSeatBg}`
                    : `${style.btnGray}`,
                  'btn-ripple rounded color-white px-3 py-1 text-center fs_20'
                )}
                style={addSeatServerAppScreen.tableButton}
                rippleEffect={true}
              >
                {LABEL().TABLE}
              </TouchableDiv>
            </div>
            <div className={cn('overflowX d-flex')}>
              <MenuSeats handleSeatClick={item => props.setPosition(item)} />
            </div>
          </div>
          <div className={cn('d-flex px-0 justify-content-end')}>
            <div
              className={cn(
                'pr-0 pl-1 d-flex align-items-center justify-content-end'
              )}
            >
              <TouchableButton
                type="button"
                className={cn(
                  style.btnAddStyle,
                  style.btnAddStyleSCSS,
                  'fs-15 btn-ripple text-center px-1   rounded'
                )}
                onClick={event => {
                  event.preventDefault();
                  setIsAddSeatModalOpen(true);
                }}
                aria-label="plusBtn"
                rippleEffect={true}
              >
                <img
                  role="presentation"
                  src={plusSign}
                  alt="plus"
                  className={style.plusSignImg}
                />
              </TouchableButton>
            </div>
            <div
              className={cn(
                'px-1 d-flex justify-content-center align-items-center rounded',
                style.deleteBtnContainer
              )}
            >
              <TouchableButton
                type="button"
                className={cn(
                  style.btnDelStyle,
                  style.deleteBtn,
                  'fs-20  btn-ripple text-center px-2 rounded color-white'
                )}
                rippleEffect={true}
                onClick={event => {
                  event.preventDefault();
                  setIsDeleteSeatModalOpen(true);
                }}
              >
                <DeleteIcon fill="white" />
              </TouchableButton>
            </div>
          </div>
        </>
      </div>
      <AddSeatModal
        isAddSeatModalOpen={isAddSeatModalOpen}
        handleCloseModal={() => setIsAddSeatModalOpen(false)}
      />
      <DeleteSeatModal
        isDeleteSeatModalOpen={isDeleteSeatModalOpen}
        handleCloseModal={() => setIsDeleteSeatModalOpen(false)}
      />
    </div>
  );
};
const mapStateToProps = state => ({
  position: state.orders.position,
  serverAppTheme: state.theme.serverAppTheme,
  cart: state.orders.cart,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setPosition,
    },
    dispatch
  );

ServerAppContentHeader.propTypes = {
  position: PropTypes.object.isRequired,
  serverAppTheme: PropTypes.object.isRequired,
};

const MemoizedMenuContentHeader = React.memo(ServerAppContentHeader);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemoizedMenuContentHeader);
